import {
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

import { NavigateFunction } from 'react-router-dom';
import { generateStateString } from '../../../utils/auth';
import { CustomNavigationClient } from './NavigationClient';
import {
  loginRequest,
  msalConfig,
  onedriveRequest,
  sharepointRequest,
} from './authConfig';

export class Microsoft {
  public static async loginRedirect(
    instance: IPublicClientApplication,
    navigate: NavigateFunction,
  ) {
    try {
      // Check if there's an interaction in progress
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        // If there are accounts, try to handle the existing interaction
        await instance.handleRedirectPromise();
      }

      instance.setNavigationClient(new CustomNavigationClient(navigate));
      loginRequest.state = generateStateString();

      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Microsoft login error:', error);
      // If there's an error, clear the interaction state and retry
      instance.setActiveAccount(null);
      await instance.loginRedirect(loginRequest);
    }
  }

  public static authOnedriveRedirect(
    instance: IPublicClientApplication,
    navigate: NavigateFunction,
  ) {
    instance.setNavigationClient(new CustomNavigationClient(navigate));

    instance.acquireTokenRedirect(onedriveRequest);
    // instance.loginRedirect(onedriveRequest);
  }

  public static authSharepointRedirect(
    instance: IPublicClientApplication,
    navigate: NavigateFunction,
  ) {
    instance.setNavigationClient(new CustomNavigationClient(navigate));
    instance.acquireTokenRedirect(sharepointRequest);
  }

  public static initialize(clientId?: string): IPublicClientApplication {
    msalConfig.auth.redirectUri = `${window.location.origin}/auth/microsoft/callback`;
    msalConfig.auth.clientId = clientId ?? msalConfig.auth.clientId;

    return new PublicClientApplication(msalConfig);
  }
}
